import { render, staticRenderFns } from "./profile.form.vue?vue&type=template&id=7a150b92"
import script from "./profile.form.vue?vue&type=script&lang=js"
export * from "./profile.form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports